import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button, Input } from "antd";

import frontMan from "../images/front_b_rotate.png";
import backMan from "../images/back_b_rotate.png";
import leftMan from "../images/left_b_rotate.png";
import rightMan from "../images/right_b_rotate.png";
import TestUI from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { useEffect, useRef, useState } from "react";
import "../App.css";
import heic2any from "heic2any";
import React from "react";

const PosturalExam4Photos_TakePhotos = ({
  images,
  getWebcamPhoto,
  loadPhoto,
}: {
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
}) => {
  const ref1 = useRef<any>();
  const ref2 = useRef<any>();
  const ref3 = useRef<any>();
  const ref4 = useRef<any>();

  //try load Heic

  const inputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = async (e: { target: { files: any[] } }) => {
    if (!inputRef.current) return;

    const file = e.target.files[0];
    if (!file) return;
    const convertedBlobOrArray = await heic2any({
      blob: file,
      toType: "image/png",
    });

    const convertedBlob = Array.isArray(convertedBlobOrArray)
      ? convertedBlobOrArray[0] // Se è un array, seleziona il primo elemento
      : convertedBlobOrArray; // Altrimenti, utilizza direttamente l'oggetto Blob

    // Ora puoi utilizzare il blob convertito come desideri
    console.log(convertedBlob);

    // Esempio: converti il blob in un'URL di oggetto e visualizzalo
    const imageUrl = URL.createObjectURL(convertedBlob);
    console.log(imageUrl);

    // Resetta l'input per consentire il caricamento di un'altra foto
    inputRef.current.value = "";
  };

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function handleTakePhoto(dataUri: string) {
    throw new Error("Function not implemented.");
  }

  return (
    <>
      {width > 640 && (
        //Desktop Mode
        <div className="centered" style={{ width: "64%" }}>
          <Row>
            <Col span={1} />
            <Col span={10}>
              <Image
                style={{
                  borderRadius: "25px",
                }}
                fallback={frontMan}
                preview={
                  images.length >= 1 && images[0].url != photoNotTakenYet.url
                }
                src={(images.length >= 1 && images[0].url) || frontMan}
              />
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(0)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={2} />
            <Col span={10}>
              <Image
                style={{
                  borderRadius: "25px",
                }}
                fallback={leftMan}
                preview={
                  images.length >= 2 && images[1].url != photoNotTakenYet.url
                }
                src={(images.length >= 2 && images[1].url) || leftMan}
              />
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(1)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref2.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref2}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(1, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                      ? images[1].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 2 && images[1].url != photoNotTakenYet.url ? (
                  images[1].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
          <Row style={{ marginTop: "8px" }}>
            <Col span={1} />
            <Col span={10}>
              <Image
                style={{
                  borderRadius: "25px",
                }}
                fallback={backMan}
                preview={
                  images.length >= 3 && images[2].url != photoNotTakenYet.url
                }
                src={(images.length >= 3 && images[2].url) || backMan}
              />
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(2)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref3.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(2, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>

              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 3 && images[2].url != photoNotTakenYet.url
                      ? images[2].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 3 && images[2].url != photoNotTakenYet.url ? (
                  images[2].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={2} />
            <Col span={10}>
              <Image
                style={{
                  borderRadius: "25px",
                }}
                fallback={rightMan}
                preview={
                  images.length == 4 && images[3].url != photoNotTakenYet.url
                }
                src={(images.length == 4 && images[3].url) || rightMan}
              />

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(3)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref4.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref4}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(3, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 4 && images[3].url != photoNotTakenYet.url
                      ? images[3].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 4 && images[3].url != photoNotTakenYet.url ? (
                  images[3].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
        </div>
      )}

      {width <= 640 && (
        //Mobile Mode
        <div className="centrados" style={{ width: "64%" }}>
          <Row>
            <Col span={11}>
              <Image
                style={{
                  borderRadius: "25px 15px 15px 15px",
                }}
                fallback={frontMan}
                preview={
                  images.length >= 1 && images[0].url != photoNotTakenYet.url
                }
                src={(images.length >= 1 && images[0].url) || frontMan}
              />

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>


            <Col span={2} />
            <Col span={11}>
              <Image
                style={{
                  borderRadius: "15px 15px 15px 15px",
                }}
                fallback={leftMan}
                preview={
                  images.length >= 2 && images[1].url != photoNotTakenYet.url
                }
                src={(images.length >= 2 && images[1].url) || leftMan}
              />

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref2.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref2}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(1, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                      ? images[1].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 2 && images[1].url != photoNotTakenYet.url ? (
                  images[1].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>

            <Col span={11}>
              <Image
                style={{
                  borderRadius: "15px 15px 15px 15px",
                }}
                fallback={backMan}
                preview={
                  images.length >= 3 && images[2].url != photoNotTakenYet.url
                }
                src={(images.length >= 3 && images[2].url) || backMan}
              />

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref3.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(2, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>

              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 3 && images[2].url != photoNotTakenYet.url
                      ? images[2].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 3 && images[2].url != photoNotTakenYet.url ? (
                  images[2].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={2} />
            <Col span={11}>
              <Image
                style={{
                  borderRadius: "15px 25px 15px 15px",
                }}
                fallback={rightMan}
                preview={
                  images.length == 4 && images[3].url != photoNotTakenYet.url
                }
                src={(images.length == 4 && images[3].url) || rightMan}
              />

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref4.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref4}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(3, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 4 && images[3].url != photoNotTakenYet.url
                      ? images[3].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 4 && images[3].url != photoNotTakenYet.url ? (
                  images[3].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
          </Row>
        </div>
      )}
      {width <= 640 && <></>}
    </>
  );
};

const PosturalExam4PhotosRight = ({
  page,
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setTestSelection,
}: {
  page: number;
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);
  return (
    <>
      {page == 0 && (
        <PosturalExam4Photos_TakePhotos
          loadPhoto={loadPhoto}
          images={images}
          getWebcamPhoto={getWebcamPhoto}
        />
      )}
      {page == 1 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 0 ? testDefinitions[0] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 1
                ? posturalExamination.testSelections[0]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 1 ? testDefinitions[1] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 1
                ? posturalExamination.testSelections[1]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 2 ? testDefinitions[2] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 2
                ? posturalExamination.testSelections[2]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 2 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 3 ? testDefinitions[3] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 3
                ? posturalExamination.testSelections[3]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <Row>
            <Col className="colph11">
              <TestUI
                testDefinition={
                  testDefinitions.length > 4 ? testDefinitions[4] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 4
                    ? posturalExamination.testSelections[4]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
            <Col span={2} />
            <Col className="colph11">
              <TestUI
                testDefinition={
                  testDefinitions.length > 5 ? testDefinitions[5] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 5
                    ? posturalExamination.testSelections[5]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
        </>
      )}
      {page == 3 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 6 ? testDefinitions[6] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 6
                ? posturalExamination.testSelections[6]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <Row>
            <Col span={24}>
              <TestUI
                testDefinition={
                  testDefinitions.length > 7 ? testDefinitions[7] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 7
                    ? posturalExamination.testSelections[7]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
            <Col span={24}>
              <TestUI
                testDefinition={
                  testDefinitions.length > 8 ? testDefinitions[8] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 8
                    ? posturalExamination.testSelections[8]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
        </>
      )}
      {page == 4 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 9 ? testDefinitions[9] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 9
                ? posturalExamination.testSelections[9]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <Row>
            <Col className="colph11">
              <TestUI
                testDefinition={
                  testDefinitions.length > 10 ? testDefinitions[10] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 10
                    ? posturalExamination.testSelections[10]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
            <Col span={2} />
            <Col className="colph11">
              <TestUI
                testDefinition={
                  testDefinitions.length > 11 ? testDefinitions[11] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 11
                    ? posturalExamination.testSelections[11]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
             
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default PosturalExam4PhotosRight;

function fromHeic(arrayBuffer: void) {
  throw new Error("Function not implemented.");
}
